function BikeQuoteConfiguration(){
	this.coverTypeClasses = {
		comprehensive : {
			label : 'Comprehensive',
			subClasses : {
				standard: {
					label: 'Comprehensive',
					descriptor: 'comprehensive',
					superType: 'comprehensive'
				},
			}
		},
		third_party: {
			label: 'Third Party',
			subClasses : {
				standard: {
					label: 'Third party only',
					descriptor: 'thirdpartyonly',
					superType: 'third_party'
				},
				fire_and_theft: {
					label: 'Third party fire and theft',
					descriptor: 'thirdpartyfiretheft',
					superType: 'third_party'
				},
			}
		}
	};

	this.allCoverTypes = {
		comprehensive_standard: this.coverTypeClasses.comprehensive.subClasses.standard,
		third_party_fire_theft:this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party_standard:  this.coverTypeClasses.third_party.subClasses.standard,
		// platinum: this.coverTypeClasses.platinum.subClasses.standard,
	};

	this.allCoverTypesByKey = {
		comprehensive: this.coverTypeClasses.comprehensive.subClasses.standard,
		third_party_fire_theft: this.coverTypeClasses.third_party.subClasses.fire_and_theft,
		third_party: this.coverTypeClasses.third_party.subClasses.standard,
	};


	this.allPaymentFrequencies = {
		annual: 'everyyear',
		monthly: 'monthly',
		fortnightly: 'everyotherweek'
	};

	this.defaultPaymentFrequency = 'annual' ; // this.allPaymentFrequencies.annual;

	this._reversePaymentFrequenciesLookup = {
		yearly: 'annual',
		monthly: 'monthly',
		fortnightly: 'fortnightly'
	};

	this.allQuoteTypes = {
		full: 'Full',
		quick: 'Quick',
	};

	this.quoteRuleOptions = {
		// Rapid estimate quote options
		'rapidEstimate': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.estimate' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'bike.riders': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.rider' // Note : THESE ARE GUIDEWIRE RULESET AND DO NOT NECESSARILY CORRESPOND TO PAGE NAMES.
			},
			permutations: {
				quoteType: this.allQuoteTypes.quick,
				// coverTypes: Object.values(this.allCoverTypes),
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.quote': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.quote'
			},
			permutations: {
				// coverTypes: Object.values(this.allCoverTypes),
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual, this.allPaymentFrequencies.monthly]
			}
		},
		'bike.contact': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.contacts'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.payment': {
			rules : {
				price: true,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.payment'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: Object.values(this.allPaymentFrequencies)
			}
		}
	};

	this.testQuoteDeclineOptions = {
		'bike.bike' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.motorcycle'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.riders' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.rider'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		},
		'bike.quote' : {
			rules : {
				price: false,
				quote: true,
				purchase: false,
				ruleSet: 'motorcycle.quote'
			},
			permutations: {
				quoteType: this.allQuoteTypes.full,
				paymentFrequencies: [this.allPaymentFrequencies.annual]
			}
		}
	}

	this.defaultCoverType = this.allCoverTypes.comprehensive_standard;

	this.defaultRequotePageName = 'bike.quote';
}
